// 枚举值

// 下载状态
export enum Status {
  WAITING = "waiting", // 等待
  PROGRESS = "progress", // 进行中
  ERROR = "error", // 失败
  SUCCESS = "success", // 下载成功
  //
  CANCEL = "cancel", // 取消
  RETRY = "retry" // 重试 注意重试状态实际是没有 只有‘等待’或者‘进行中’状态时，断网了 就会变成重试状态
}

// 下载按钮文字
export enum BtnText {
  CANCEL = "取消",
  RETRY = "重试",
  OPEN = "查看",
  ERROR = "重试"
}

// 下载文案描述
export enum StatusDesc {
  PROGRESS = "已下载",
  CANCEL = "已取消下载",
  SUCCESS = "已完成下载"
}

export enum ErrorCode {
  NO_PERMISSION = "40003", // 无权限
  NETWORK_ERROR = -2,
  FILE_DEL_ERROR = "40433", // 源文件被删除了
  ERROR = -99,
  PATH_NOT_EXIST = "40000", // 下载路径不存在
  PRIVATENET_EGOV_FILE = -1,
  FILE_EXPIRED = "1017005", // 文件过期
  FILE_CHECK_PROCESS_ERROR = "10270061", // 正在进行安全扫描，请稍后重试
  FILE_CHECK_FAIL_ERROR = "10270062", // 该文件存在安全隐患, 无法操作
  FILE_CHECK_LIMIT = "10270041" // 限流
}

export enum StatusErrorDesc {
  NETWORK_ERROR = "网络异常",
  FILE_DEL_ERROR = "源文件已被删除",
  NO_PERMISSION = "暂无下载权限",
  ERROR = "下载失败",
  PATH_NOT_EXIST = "文件路径不存在",
  PRIVATENET_EGOV_FILE = "仅支持政务外网下载",
  FILE_EXPIRED = "文件已过期",
  FILE_CHECK_PROCESS_ERROR = "正在进行安全扫描，请稍后重试",
  FILE_CHECK_FAIL_ERROR = "该文件存在安全隐患, 无法操作"
}

// 全局下载状态，主要用于面板最上边
export enum GlobalStatus {
  PROGRESS_ALL = "progress", // 下载中
  CANCEL_ALL = "cancel", // 全部取消
  SUCCESS_ALL = "success", // 全部下载成功
  ERROR_ALL = "error", // 全部下载失败
  MOIETY_ERROR = "moiety_error" // 部分下载失败
}
// 全局下载状态描述
export enum GlobalStatusText {
  PROGRESS_ALL = "下载中",
  CANCEL_ALL = "下载已取消",
  SUCCESS_ALL = "全部下载成功",
  ERROR_ALL = "全部下载失败",
  MOIETY_ERROR = "部分下载失败"
}

// 全局按钮状态
export enum GlobalBtnStatus {
  CANCEL_ALL = "cancel_all", // 全部取消
  RETRY_ALL = "retry_all" // 全部重试
}

// 全局按钮描述
export enum GlobalBtnStatusText {
  CANCEL_ALL = "全部取消",
  RETRY_ALL = "全部重试"
}

// 全局按钮描述
export enum GlobalBtnStatusDesc {
  PROGRESS_ALL = "已下载"
}

export interface DownloadOptions {
  onStarted: (item: any) => void;
  onProgress: (item: any) => void;
  onCancel: () => void;
  onPause: () => void;
  onResume: () => void;
  onFinish: (file: any) => void;
  onError: (errorCode: ErrorCode) => void;
  openDownloadPath: () => void;
}
export interface BatchDownloadItem {
  id: string;
  pageId: string;
  title: string;
  currentSize: string;
  currentProgress: number;
  size: string;
  imgUrl: string;
  status: Status | ErrorCode;
  index?: number;
  options: DownloadOptions;
  applyFn: Status;
  path: string;
  gid?: string;
  type?: string;
  pause?: () => void;
  resume?: () => void;
  cancel?: () => void;
  onProgress?: () => void;
  onStart?: () => void;
}
